( function( $ ) {
	$( document ).ready( function() {
		var $podcast = $( '.podcast-embed' );
		if ( !$podcast.length ) { return; }

		var $iframe = $podcast.find( '.podcast-embed__iframe' );
		var dataSrc = $iframe.data( 'src' );

		$iframe.attr( 'src', dataSrc );
	} );
} )( jQuery );